module.exports = __webpack_public_path__ + "b1054396.svg";